<template>
  <div class="container">
    <QueryFrame

      @handlePage="handlePage"
      @handlePageSize="handlePageSize"

      :count="count"
      :current="page"
    >
      <div slot="queryParams" class="form">
        <div class="queryContainer">
          <div class="queryItem">
            <label>账户名:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.phone"></lk-input>
          </div>
          <div class="queryItem">
            <label>姓名:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.name"></lk-input>
          </div>
          <div class="queryItem">
            <label>管理省份:</label>
            <lk-select class="item" clearable v-model.trim="query.provinceId">
              <lk-option v-for="item in managerProvinceList" :key="item.id" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>状态:</label>
            <lk-select class="item" clearable v-model.trim="query.status">
              <lk-option v-for="item in [{name: '启用', id: 1}, {name: '停用', id: 2}]" :key="item.id" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>角色:</label>
            <lk-select class="item" filterable clearable v-model.trim="query.roleId">
              <lk-option v-for="item in headOfficeRoles" :key="item.id" :value="item.id">{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="clear">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btnContainer">
<lk-button @click="addNew" icon='md-add' v-if="handlePermission('headOfficeAccountAdd')" type='primary' >新建总部账户</lk-button>
<lk-button @click="exportList" icon='md-add' v-if="handlePermission('headOfficeAccountExport')" type='primary' >导出Excel</lk-button>
        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '@/components/frame/QueryFrame.vue';
import system from '@/services/system';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';

export default {
  name: 'HeadOfficeAccountList',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  data() {
    return {
      headOfficeRoles: [],
      query: {
        phone: '',
        name: '',
        provinceId: '',
        roleId: '',
        status: '',
      },
      columns: [
        { title: '账户ID', key: 'sysUserId', minWidth: 116 },
        { title: '账户名', key: 'sysUserPhone', minWidth: 116 },
        { title: '姓名', key: 'sysUserName', minWidth: 116 },
        {
          title: '管理省份',
          key: 'provinceId',
          minWidth: 116,
          render: (h, params) => h('span', params.row.provinceNameList.join(', ')),
        },
        {
          title: '角色',
          key: 'roleStrList',
          minWidth: 116,
        },
        {
          title: '状态',
          key: 'sysUserStatus',
          minWidth: 116,
          render: (h, params) => (this.handlePermission('headOfficeAccountEnableDisable') ? h('lk-switch', {

            props: {
              size: 'large',
              value: params.row.sysUserStatus === 1,
              loading: params.row.loading,
            },
            on: {
              'on-change': (flag) => {
                params.row.loading = true;
                const toggleFunction = flag ? system.userEnable : system.userDisable;
                const Message = flag ? '该用户已启用' : '该用户已禁用';
                toggleFunction({ sysUser: { id: params.row.sysUserId }, sysStore: { id: params.row.sysStoreId } }).then((res) => {
                  if (res.data.status === 200) {
                    this.$Message.success(Message);
                    params.row.loading = false;
                  } else {
                    params.row.loading = false;
                    this.$Message.error(res.data.error);
                    this.getData();
                  }
                }).catch((err) => {
                  this.getData();
                  utils.handleError(err);
                });
              },
            },
          }, [
            h('span', {
              props: {
              },
              slot: 'open',
            }, '启用'),
            h('span', {
              props: {
              },
              slot: 'close',
            }, '禁用'),
          ]) : h('span', params.row.sysUserStatus === 1 ? '启用' : '禁用')),
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, params) => h('div', {
            class: {
              textCenter: true,
            },
          }, [
            this.handlePermission('headOfficeAccountInfo') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'headOfficeAccountInfo', params: { id: params.row.sysUserId } });
                },
              },
            }, '查看') : null,
            this.handlePermission('headOfficeAccountEdit') ? h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.$router.push({ name: 'headOfficeAccountEdit', params: { id: params.row.sysUserId } });
                },
              },
            }, '修改') : null,
          ]),
        },
      ],
      tableData: [],
      managerProvinceList: [], // 管理省份列表
    };
  },
  methods: {
    getRoleInfos() {
      system.storeListEnable({ type: 1, page: 1, size: 10000 }).then((res) => {
        if (res.data.status === 200) {
          this.headOfficeRoles = res.data.data.list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // 获取管理省份列表
    getManagerProvinceList() {
      this.$store.commit('setDisableLoading', true);
      system.getLocation(1).then((res) => {
        if (res.data.status === 200) {
          this.managerProvinceList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      this.$route.params.create ? this.params.create = true : this.params.create = '';

      system.userList(this.params).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.loading = false;
            // 处理总部角色 将id转为字符串
            const roleStrList = [];

            item.roleList && item.roleList.forEach((subItem) => {
              roleStrList.push(subItem.name);
            });
            result.roleStrList = roleStrList.join(', ');
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    // handleSearch() {
    //   this.page = 1;
    //   this.getData();
    // },
    // handlePage(page) {
    //   this.page = page;
    //   this.getData();
    // },
    // handlePageSize(size) {
    //   this.size = size;
    //   this.getData();
    // },
    addNew() {
      this.$router.push({ name: 'headOfficeAccountAdd', params: { flag: 0 } });
    },
    clear() {
      this.query = {
        phone: '',
        name: '',
        provinceId: '',
        roleId: '',
        status: '',
      };
    },
    exportList() {
      this.$route.params.create ? this.params.create = true : this.params.create = '';
      const temp = utils.deepClone(this.params);
      delete temp.page;
      delete temp.size;
      system.headOfficeListExport(temp).then((res) => {
        if (res.status === 200) {
          utils.downFile(res.data, `总部账户${utils.formatTime(new Date().getTime(), 'YYYYMMDD')}.xlsx`);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getManagerProvinceList();
    this.getRoleInfos();
    // this.getData();
    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
.btnContainer{
  margin-bottom: 12px;
  margin-top:2px;
  >*:first-child{
    margin-right: 8px
  }

}
  .queryContainer{
    display: flex;
    padding-bottom: 16px;
    flex-wrap: wrap;
    .queryItem{
      display: flex;
      align-items: center;
      margin-right: 32px;
      flex-wrap: wrap;
      margin-bottom: 15px;
      .item{
        display: inline-block;
        width: 256px
      }
    }
  }
</style>
